import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PROJECTS } from "../lib/site";

export default function Portfolio() {
  return (
    <div data-testid="page-portfolio">
      {/* HEADER */}
      <section className="bg-navy text-white">
        <div className="container-pro pt-24 pb-20 md:pt-32 md:pb-28">
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-slateblue-400">
            06 / PROJECT PORTFOLIO
          </span>
          <h1 className="mt-6 font-heading font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl max-w-4xl leading-[1.05]">
            Selected NYCT MTA contracts.
          </h1>
          <p className="mt-8 text-base md:text-lg text-white/75 max-w-2xl leading-relaxed">
            A representative sample of recent transit electrical engineering
            deliverables across signaling, traction power, station systems
            and SCADA.
          </p>
        </div>
      </section>

      {/* PROJECTS GRID */}
      <section className="bg-white section-pad">
        <div className="container-pro">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
            {PROJECTS.map((p) => (
              <article
                key={p.id}
                data-testid={`portfolio-item-${p.id}`}
                className={`group relative ${p.span} overflow-hidden border border-hairline-dark bg-navy text-white`}
              >
                <div className="relative h-80 md:h-[32rem] overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title}
                    className="w-full h-full object-cover opacity-55 group-hover:opacity-80 group-hover:scale-[1.03] transition-all duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/50 to-navy/10" />
                </div>

                <div className="absolute inset-0 p-7 md:p-10 flex flex-col">
                  <div className="flex items-center justify-between">
                    <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-slateblue-400">
                      {p.code}
                    </span>
                    <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-slateblue-400">
                      {p.year}
                    </span>
                  </div>

                  <div className="mt-auto">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-slateblue-400">
                        {p.discipline}
                      </span>
                      <span className="h-px w-8 bg-slateblue-400/60" />
                      <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-slateblue-400">
                        {p.scope}
                      </span>
                    </div>
                    <h3 className="font-heading font-bold text-xl md:text-2xl max-w-lg leading-tight">
                      {p.title}
                    </h3>
                    <p className="mt-4 text-sm text-white/75 max-w-xl leading-relaxed">
                      {p.summary}
                    </p>
                    {p.stats && (
                      <div className="mt-6 pt-5 border-t border-white/15 grid grid-cols-3 gap-4">
                        {p.stats.map((s) => (
                          <div key={s.k}>
                            <div className="font-heading font-bold text-base md:text-lg text-white">
                              {s.v}
                            </div>
                            <div className="mt-1 font-mono text-[9px] md:text-[10px] uppercase tracking-[0.18em] text-slateblue-400">
                              {s.k}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-surface-alt border-t border-hairline">
        <div className="container-pro py-16 md:py-20 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-8">
            <span className="overline">07 / NEXT</span>
            <h3 className="mt-4 font-heading font-black text-3xl md:text-4xl text-navy tracking-tight max-w-3xl">
              Looking for a contractor familiar with NYCT submittal cycles?
            </h3>
            <p className="mt-4 text-base text-slate-600 max-w-xl leading-relaxed">
              Send us your scope. We’ll respond with a deliverables matrix,
              schedule, and pricing within 48 hours.
            </p>
          </div>
          <div className="lg:col-span-4 flex lg:justify-end">
            <Link
              to="/contact"
              data-testid="portfolio-cta-contact"
              className="btn-primary"
            >
              Submit a Scope
              <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
